import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/kefu.png'


const _withScopeId = n => (_pushScopeId("data-v-7bf6fa61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right-contents" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"contents-item\" data-v-7bf6fa61><p class=\"contents-item-title\" data-v-7bf6fa61>1. 已经扣款，但订单仍显示【等待付款】</p><ul class=\"title-ul\" data-v-7bf6fa61><li data-v-7bf6fa61> 若您交易已扣款，交易状态显示等待付款，一般是由于网络繁忙导致数据延迟，您可以尝试再次刷新订单页面； </li><li data-v-7bf6fa61> 若订单一直显示“等待付款”或出现“交易关闭”等情况，请联系客服，将该笔款项退回到您的银行卡、支付宝或微信账户中。 </li></ul></div><div class=\"contents-item\" data-v-7bf6fa61><p class=\"contents-item-title\" data-v-7bf6fa61>2. 重复扣款</p><ul class=\"title-ul\" data-v-7bf6fa61><li data-v-7bf6fa61> 若您同一笔交易被重复扣款，请不要担心，多付钱款会原路退回，请关注您的支付宝、微信付款账号或银行卡账户。 </li><li data-v-7bf6fa61>温馨提醒：若重复钱款仍未退回，可联系客服帮助您解决。</li></ul></div><div class=\"contents-item\" data-v-7bf6fa61><p class=\"contents-item-title\" data-v-7bf6fa61>3. 交易因网络原因无法反馈结果</p><ul class=\"title-ul\" data-v-7bf6fa61><li data-v-7bf6fa61> 若您因网络原因无法支付成功或暂时无法反馈结果，请您稍后至交易发起的应用/网站（如支付宝/微信/网银）查看。 </li></ul></div>", 3)
const _hoisted_5 = { class: "contents-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "contents-item-title" }, "4.其他", -1))
const _hoisted_7 = { class: "title-ul" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "（1）拨打热线电话：15522415492，描述您遇到的问题。", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "（2）联系在线客服:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "我的订单", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_customer_title = _resolveComponent("customer-title")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_customer_title, { list: _ctx.titleList }, null, 8, ["list"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("ul", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("li", null, [
            _hoisted_9,
            _createElementVNode("div", {
              class: "img",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fangankefu && _ctx.fangankefu(...args)))
            }, _hoisted_11)
          ]),
          _createElementVNode("li", null, [
            _createTextVNode(" 如未支付成功请跳转至 "),
            _createVNode(_component_router_link, { to: "/user/myorder" }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createTextVNode(" 找到遇到问题的待付款订单，完成交易。 ")
          ])
        ])
      ])
    ])
  ], 64))
}